import React from 'react'
import logo from "../assets/images/logo.png"
const Logo = () => {
  return <img src={logo} alt="jobify" className='logo'/>
}
export default Logo;

